import type { ThemePalette } from "./types";

export const rosePine: ThemePalette = {
	id: "rose-pine",
	name: "Rose Pine",
	family: "rose-pine",
	appearance: "dark",

	background: "#191724",
	foreground: "#e0def4",
	card: "#1f1d2e",
	cardForeground: "#e0def4",
	popover: "#26233a",
	popoverForeground: "#e0def4",

	primary: "#c4a7e7",
	primaryForeground: "#191724",
	secondary: "#21202e",
	secondaryForeground: "#e0def4",
	muted: "#21202e",
	mutedForeground: "#6e6a86",
	accent: "#ebbcba",
	accentForeground: "#191724",
	destructive: "#eb6f92",
	destructiveForeground: "#191724",

	border: "#403d52",
	input: "#21202e",
	ring: "#c4a7e7",

	success: "#9ccfd8",
	warning: "#f6c177",
	error: "#eb6f92",
	info: "#31748f",

	chart1: "#c4a7e7",
	chart2: "#31748f",
	chart3: "#f6c177",
	chart4: "#eb6f92",
	chart5: "#9ccfd8",
};

export const rosePineMoon: ThemePalette = {
	id: "rose-pine-moon",
	name: "Rose Pine Moon",
	family: "rose-pine",
	appearance: "dark",

	background: "#232136",
	foreground: "#e0def4",
	card: "#2a273f",
	cardForeground: "#e0def4",
	popover: "#393552",
	popoverForeground: "#e0def4",

	primary: "#c4a7e7",
	primaryForeground: "#232136",
	secondary: "#2a283e",
	secondaryForeground: "#e0def4",
	muted: "#2a283e",
	mutedForeground: "#6e6a86",
	accent: "#ea9a97",
	accentForeground: "#232136",
	destructive: "#eb6f92",
	destructiveForeground: "#232136",

	border: "#44415a",
	input: "#2a283e",
	ring: "#c4a7e7",

	success: "#9ccfd8",
	warning: "#f6c177",
	error: "#eb6f92",
	info: "#3e8fb0",

	chart1: "#c4a7e7",
	chart2: "#3e8fb0",
	chart3: "#f6c177",
	chart4: "#eb6f92",
	chart5: "#9ccfd8",
};

export const rosePineDawn: ThemePalette = {
	id: "rose-pine-dawn",
	name: "Rose Pine Dawn",
	family: "rose-pine",
	appearance: "light",

	background: "#faf4ed",
	foreground: "#575279",
	card: "#fffaf3",
	cardForeground: "#575279",
	popover: "#f2e9e1",
	popoverForeground: "#575279",

	primary: "#907aa9",
	primaryForeground: "#faf4ed",
	secondary: "#f4ede8",
	secondaryForeground: "#575279",
	muted: "#f4ede8",
	mutedForeground: "#9893a5",
	accent: "#d7827e",
	accentForeground: "#faf4ed",
	destructive: "#b4637a",
	destructiveForeground: "#faf4ed",

	border: "#dfdad9",
	input: "#f4ede8",
	ring: "#907aa9",

	success: "#286983",
	warning: "#ea9d34",
	error: "#b4637a",
	info: "#56949f",

	chart1: "#907aa9",
	chart2: "#286983",
	chart3: "#ea9d34",
	chart4: "#b4637a",
	chart5: "#56949f",
};
